// extracted by mini-css-extract-plugin
export var amountPaidColumn = "_gg-6";
export var emphasizeQuantity = "_gg-3";
export var flatBottomCorners = "_gg-5";
export var productImage = "_gg-0";
export var quantityContainer = "_gg-2";
export var tooltip = "_gg-1";
export var wrapAndEllipsesOverflow = "_gg-4";